import {BASE_SUBDOMAIN} from "../helpers/UrlHelper";

const {createBrowserHistory} = require("history");
 const history = createBrowserHistory({
  basename:BASE_SUBDOMAIN
 });
export default history;
